import bigDecimal, { round } from "js-big-decimal"
import { isEmpty, validateForm } from "../../../services/functions"
import moment from "moment"

export const paymentPurchaseColumns = ["docNumber","connectionTransactional.name","sellerTin","supplierCode","purchaseUnit","fic","actions","print","recordDateTime","dueDateTime","internalStatus","purchaseStatus","currency","exRate","amountInAll","amount"]



export const defaultPaymentOrder={
    issueDateTime:new Date(),
    currency:"ALL",
    description:"",
    creditorAccountReferenceType:"IBAN",
    paymentOrderRecords:[
      {
        docNumber:null,
        eInvoiceFic:null,
        dueDate:null,
        invoiceAmount:null,
        internalStatus:null,
        buyerPaidAmount:null,
        description:"",

      }
    ],
    sellerBankAccountTransactional:{
      sellerName:  "",
      sellerNipt:  "",
      sellerIban: "",
      creditorAccountReferenceType: "IBAN",
      creditorBankName:  "",
      creditorAccountReference: "",
      creditorAgent:  "",
      creditorAccountReferenceCurrency: "ALL"
    }
  }

export const mapPurchaseInvoice=(invoice, defaultDescription = "")=>{
  const eInvoiceAmount = invoice?.currency === "ALL" ? invoice?.amountInAll : invoice?.amount;
  return {
    docNumber:invoice?.docNumber,
    eInvoiceFic:invoice?.fic,
    dueDateTime:invoice.dueDateTime,
    eInvoiceAmount,
    buyerPaidAmount:eInvoiceAmount,
    purchaseWorkflowStatus:invoice.internalStatus,
    cisStatus:invoice.purchaseStatus,
    description: defaultDescription,
    exRate:invoice.exRate,
    purchaseInvoiceId:invoice.id,
    issueDateTime:invoice.recordDateTime
  }
}

export const mapContactToSellerBankAccount =(contactAccount={})=>{
  return {
    sellerName: contactAccount?.contact?.name ?? "",
    sellerNipt: contactAccount?.contact?.idValue ?? "",
    sellerIban: contactAccount?.iban ?? "",
    creditorAccountReferenceType: "IBAN",
    creditorBankName: contactAccount?.financialInstitution?.name ?? "",
    creditorAccountReference: contactAccount?.accountNo ?? "",
    creditorAgent: contactAccount?.financialInstitution?.bic ?? "",
    creditorAccountReferenceCurrency: contactAccount?.currency ?? "",
    contactId: contactAccount?.contact?.id
  }
}

export const mapContactToBuyerBankAccount =({account={},company}={})=>{
  return {
    buyerName: company.name,
    buyerNipt: company.nuis,
    buyerIban: account.iban,
    buyerAccountReferenceType: "IBAN",
    buyerBankName: account?.financialInstitution?.name,
    buyerAccountReference: account?.accountNo,
    buyerAgent: account?.financialInstitution?.bic,
    buyerAccountReferenceCurrency: account?.currency
  }
}




export const calculatePaymentOrderData=(state)=>{
  const {paymentOrderRecords=[]} = state
  const invoicesTotal = paymentOrderRecords.reduce((acc, inv) => bigDecimal.add(acc,inv.amountInAll), "0");

  return {invoicesTotal: round(invoicesTotal,2)}

}


export const validateSellerBankAccount = (sellerBankAccount = {}) => {
  const requiredFields = [
    "sellerName",
    "sellerNipt",
    "sellerIban",
    "creditorBankName",
    "creditorAgent",
    "creditorAccountReferenceCurrency"
  ];

  const missingFields = requiredFields.filter(field => isEmpty(sellerBankAccount[field]));

  return {
    isValid: missingFields.length === 0,
    missingFields
  };
};

export const sellerBankAccountValidateFields = [
  { value: "sellerName", label: "Seller Name" },
  { value: "sellerNipt", label: "Seller NIPT" },
  { value: "sellerIban", label: "Seller IBAN" },
  { value: "creditorBankName", label: "Creditor Bank Name" },
  { value: "creditorAgent", label: "Creditor Agent" },
  { value: "creditorAccountReferenceCurrency", label: "Currency" }
];

export const buyerBankAccountValidateFields = [
  { value: "buyerName", label: "Buyer Name" },
  { value: "buyerNipt", label: "Buyer NIPT" },
  { value: "buyerIban", label: "Buyer IBAN" },
  { value: "buyerAccountReferenceType", label: "Buyer Account Reference Type" },
  { value: "buyerBankName", label: "Buyer Bank Name" },
  { value: "buyerAccountReference", label: "Buyer Account Reference" },
  { value: "buyerAgent", label: "Buyer Agent" },
  { value: "buyerAccountReferenceCurrency", label: "Buyer Account Reference Currency" }
];



export const validateSameCurrency = (invoices) => {
  if (invoices.length === 0) return true;

  const currencies = invoices.map(inv => inv?.currency);
  const uniqueCurrencies = new Set(currencies);

  return uniqueCurrencies.size === 1;
};

export const validateSameNipt = (invoices) => {
  if (invoices.length === 0) return true;

  const niptValues = invoices.map(inv => inv?.sellerTin);
  const uniqueNipTs = new Set(niptValues);

  return uniqueNipTs.size === 1;
};

export const paymentOrderValid = ({validateOnlyInvoicesFields=false,t,setValidationErrors,data}={}) => {
    let validateFields=[
      {
        value: "paymentOrderRecords",
        label: "Invoices",
        fields: [
          { value: "docNumber", label: "Doc Number" },
          { value: "buyerPaidAmount", label: t(["home.totAll"]) },
        ]
      }
    ]

    if(!validateOnlyInvoicesFields){

      const sellerBankAccountFieldsWithPrefix = sellerBankAccountValidateFields.map(field => ({
        value: `sellerBankAccountTransactional.${field.value}`,
        label: field.label
      }));

      const buyerBankAccountFieldsWithPrefix = buyerBankAccountValidateFields.map(field => ({
        value: `buyerBankAccountTransactional.${field.value}`,
        label: field.label
      }));

      validateFields= validateFields.concat(
        [
          ...sellerBankAccountFieldsWithPrefix,
          ...buyerBankAccountFieldsWithPrefix,
          {
            value:"issueDateTime",
            label:"Issue Date Time"
          },
        ])
    }

    const validationObj=validateForm(validateFields,data)
    if(!validationObj?.isValid){
      setValidationErrors(validationObj.errors)
      return { isValid: false, errors: validationObj.errors }
    }
    return { isValid: true, errors: {} }
};